export default [

     {
          path: '/position',
          name: 'Position',
          component: () => import("@/views/Page/Position/Position.vue"),
           meta: {
               title: 'Position',
          },
     }
];